import { ShowcaseArticleState } from 'types/store/ShowcaseArticleState';
import { createUpdateAction, createClearAction } from 'utils/Redux';

const ns = 'SHOWCASE_ARTICLE';
const updateAction = createUpdateAction<ShowcaseArticleState>(ns);
const clearAction = createClearAction(ns);

const showcaseArticleActions = {
  ...updateAction,
  ...clearAction,
};

export default showcaseArticleActions;
